
        import { i18n } from './utils/I18n.js';
        
        document.addEventListener('DOMContentLoaded', () => {
            i18n.init();
            
            const select = document.getElementById('language-select');
            if (select) {
                select.onchange = (e) => {
                    i18n.switchLanguage(e.target.value);
                };
            }
        });
    